/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MedicineViewFragmentAliases {
  CONTEXTUAL_BAR_MEDICINE_VIEW = 'contextual-bar-medicine-view',
  FIELD_ADMINISTRATION = 'field-administration',
  FIELD_APPLICATION_ROUTE = 'field-application-route',
  FIELD_DOSE = 'field-dose',
  FIELD_DURATION = 'field-duration',
  FIELD_END_DATE = 'field-end-date',
  FIELD_HOURS = 'field-hours',
  FIELD_ITEM = 'field-item',
  FIELD_MEDICAL_ORDER = 'field-medical-order',
  FIELD_PERIOD = 'field-period',
  FIELD_PRESCRIBER_DATE = 'field-prescriber-date',
  FIELD_PRESCRIBER_NAME = 'field-prescriber-name',
  FIELD_START_DATE = 'field-start-date',
  FIELD_UNIT_MEASUREMENT = 'field-unit-measurement',
  FORM_ADDICIONAL_INFORMATIONS = 'form-addicional-informations',
  FORM_MAIN_INFORMATIONS = 'form-main-informations',
  FORM_MEDICAL_ORDER = 'form-medical-order',
  FORM_PERIOD_OF_VALIDITY = 'form-period-of-validity',
  INFORMATION_BAR_HEADER = 'information-bar-header',
  INPUT_END_DATE = 'input-end-date',
  INPUT_START_DATE = 'input-start-date',
  LAYOUT_MEDICINE_VIEW = 'layout-medicine-view',
  LOADER = 'loader',
  PANEL_CARD = 'panel-card',
  PANEL_LOADER = 'panel-loader',
  PANEL_MEDICAL_ORDER = 'panel-medical-order',
  SECTION_ADDICIONAL_INFORMATIONS = 'section-addicional-informations',
  SECTION_MAIN_INFORMATIONS = 'section-main-informations',
  SECTION_MEDICAL_ORDER = 'section-medical-order',
  SECTION_PERIOD_OF_VALIDITY = 'section-period-of-validity',
  SUPPRESS_HEADING_BAR_MARGIN_ADDICIONAL_INFORMATIONS = 'suppress-heading-bar-margin-addicional-informations',
  SUPPRESS_HEADING_BAR_MARGIN_MAIN_INFORMATIONS = 'suppress-heading-bar-margin-main-informations',
  SUPPRESS_HEADING_BAR_MARGIN_MEDICAL_ORDER = 'suppress-heading-bar-margin-medical-order',
  SUPPRESS_HEADING_BAR_MARGIN_PERIOD_OF_VALIDITY = 'suppress-heading-bar-margin-period-of-validity',
  TEXT_ADMINISTRATION = 'text-administration',
  TEXT_APPLICATION_ROUTE = 'text-application-route',
  TEXT_DOSE = 'text-dose',
  TEXT_DURATION = 'text-duration',
  TEXT_HOURS = 'text-hours',
  TEXT_ITEM = 'text-item',
  TEXT_MEDICAL_ORDER = 'text-medical-order',
  TEXT_PERIOD = 'text-period',
  TEXT_PRESCRIBER_DATE = 'text-prescriber-date',
  TEXT_PRESCRIBER_NAME = 'text-prescriber-name',
  TEXT_UNIT_MEASUREMENT = 'text-unit-measurement',
}
export { MedicineViewFragmentAliases };
